import { AssetType } from '@nusign/picflow-backend-types';

interface IconMap {
  iconUrl: string;
  backgroundColor: string;
  extensions: string[];
}
interface DefaultIconMap {
  iconUrl: string;
  backgroundColor: string;
  type: AssetType;
}

export const defaultExtensionDataMap: DefaultIconMap[] = [
  {
    type: 'image',
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-image.svg',
  },
  {
    type: 'video',
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-video.svg',
  },
  {
    type: 'non_preview',
    iconUrl: '/assets/icons/files/file-generic.svg',
    backgroundColor: '#FFFFFF',
  },
  {
    type: 'audio',
    iconUrl: '/assets/icons/file-audio.svg',
    backgroundColor: '#FFFFFF',
  },
  {
    type: 'document',
    iconUrl: '/assets/icons/files/file-text.svg',
    backgroundColor: '#FFFFFF',
  },
];

export const extensionDataMap: IconMap[] = [
  {
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-text.svg',
    extensions: ['txt', 'rtf', 'rtfd', 'md', 'markdown', 'mdown', 'mdownx'],
  },
  {
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-archive.svg',
    extensions: ['zip', 'rar', '7z', 'tar', 'gz'],
  },
  {
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-list.svg',
    extensions: ['csv', 'xmp', 'xml'],
  },
  {
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-audio.svg',
    extensions: ['mp3', 'wav', 'm4a', 'ogg', 'flac', 'aac', 'm4b', 'm4p', 'm4r', 'm4b', 'm4p', 'm4r'],
  },
  {
    backgroundColor: '#FFFFFF',
    iconUrl: '/assets/icons/files/file-3d.svg',
    extensions: ['obj', 'fbx', '3ds', 'rvt', 'blend', 'stl', 'max', 'skp', 'dwg', 'dxf', 'bim'],
  },
  {
    iconUrl: '/assets/icons/files/file-font.svg',
    backgroundColor: '#FFFFFF',
    extensions: ['ttf', 'otf', 'woff', 'woff2'],
  },
  {
    iconUrl: '/assets/icons/logo/capture-one-color.svg',
    backgroundColor: '#2C8CEA',
    extensions: ['cocatalog', 'comask', 'cot', 'cop', 'cof', 'eip', 'cos'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-lightroom.svg',
    backgroundColor: '#31A8FF',
    extensions: ['lrcat', 'lrtemplate', 'lrdata'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-photoshop.svg',
    backgroundColor: '#31A8FF',
    extensions: ['psd', 'psb', 'pdd'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-illustrator.svg',
    backgroundColor: 'rgba(255, 154, 0, 0.2)',
    extensions: ['ai', 'ait'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-indesign.svg',
    backgroundColor: '#FF3366',
    extensions: ['indd', 'idml', 'indt'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-acrobat.svg',
    backgroundColor: '#B30B00',
    extensions: ['pdf', 'xfdf', 'fdf'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-aftereffects.svg',
    backgroundColor: '#9999FF',
    extensions: ['aep', 'aepx', 'aet'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-premierepro.svg',
    backgroundColor: '#9999FF',
    extensions: ['prproj', 'prel'],
  },
  {
    iconUrl: '/assets/icons/logo/adobe-audition.svg',
    backgroundColor: '#9999FF',
    extensions: ['ses', 'sesx'],
  },
  {
    iconUrl: '/assets/icons/logo/microsoft-word.svg',
    backgroundColor: '#2B7CD3',
    extensions: ['doc', 'docx', 'dotx', 'docm', 'dotm'],
  },
  {
    iconUrl: '/assets/icons/logo/microsoft-excel.svg',
    backgroundColor: '#21A366',
    extensions: ['xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm'],
  },
  {
    iconUrl: '/assets/icons/logo/microsoft-powerpoint.svg',
    backgroundColor: '#ED6C47',
    extensions: ['ppt', 'pptx', 'pptm', 'potx', 'potm'],
  },
  {
    iconUrl: '/assets/icons/logo/apple-keynote.svg',
    backgroundColor: '#1F98F7',
    extensions: ['key'],
  },
  {
    iconUrl: '/assets/icons/logo/apple-pages.svg',
    backgroundColor: '#FEA124',
    extensions: ['pages'],
  },
  {
    iconUrl: '/assets/icons/logo/apple-numbers.svg',
    backgroundColor: '#51E748',
    extensions: ['numbers'],
  },
  {
    iconUrl: '/assets/icons/logo/sketch.svg',
    backgroundColor: '#2B155A',
    extensions: ['sketch'],
  },
  {
    iconUrl: '/assets/icons/logo/figma.svg',
    backgroundColor: '#2B155A',
    extensions: ['fig'],
  },
];
